export const goToElement = (id) => {
	if (document.getElementById(id)) document.getElementById(id).focus();
};
